import { render, staticRenderFns } from "./FaqSearchFooter.vue?vue&type=template&id=4f18b255&"
import script from "./FaqSearchFooter.vue?vue&type=script&lang=js&"
export * from "./FaqSearchFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports